import React, { useState, lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { AuthContext } from "./auth";
import { useTranslation } from "react-i18next";
import PrivateRoute from "./PrivateRoute";

import axios from "axios";

// MAINTENANCE
// import Maintenance from "./components/Maintenance";

// NAV
import Header from "./components/header/Header";
import WhatsNew from "./components/WhatsNew/WhatsNew";
import SidebarCESAM from "./components/sidebar/SidebarCESAM";
import BottomNav from "./components/sidebar/BottomNav";
import NotFound from "./components/NotFound";
import Loader from "./components/Loader/Loader";
import Footer from "./components/header/Footer";
import StateModal from "./components/Loader/StateModal";

// SIGNUP - ONBOARDING


// CREATE

// SCHEDULE


// ENGAGE

// ANALYSE

// MANAGE
// import Smlink from "./components/smlink/Smlink";

// OTHER

// SUBSCRIPTION

import { LinkedInPopUp } from "react-linkedin-login-oauth2";

import "./components/styles/style.css";
import "./components/styles/forms.css";
import "./components/styles/tables.css";
import "./components/styles/theme.css";

const DashboardCesam = lazy(() => import("./components/dashboard/DashboardCesam"));
const Dashboard = lazy(() => import("./components/DashboardAdv/Dashboard"));
const Onboarding = lazy(() => import("./components/Onboarding/Onboarding"));
const OnboardingPaymentConfirmed = lazy(() => import("./components/Onboarding/OnboardingPaymentConfirmed"));
const CanvaAuth = lazy(() => import("./components/signin/CanvaAuth"));
const CanvaAuthTest = lazy(() => import("./components/signin/CanvaAuthTest"));
const SigninStripped = lazy(() => import("./components/signin/SigninStripped"));
const SignupStripped = lazy(() => import("./components/signin/SignupStripped"));
const SignupCanva = lazy(() => import("./components/signin/SignupCanva"));
const TeamSignupStripped = lazy(() => import("./components/signin/TeamSignupStripped"));
const PasswordReset = lazy(() => import("./components/signin/PasswordReset"));
const NewPassword = lazy(() => import("./components/signin/NewPassword"));
const EmailConf = lazy(() => import("./components/signin/EmailConf"));
const PostEditor = lazy(() => import("./components/Editor/PostEditor"));
const CalendarAdvanced = lazy(() => import("./components/CalendarView/CalendarAdvanced"));
const CalendarAdvancedWeek = lazy(() => import("./components/CalendarView/CalendarAdvancedWeek"));
const Drafts = lazy(() => import("./components/Drafts/Drafts"));
const GridViews = lazy(() => import("./components/Grid/GridViews"));
const CalendarThirdMonthly = lazy(() => import("./components/CalendarView/CalendarThirdParty/CalendarThirdMonthly"));
const CalendarThirdWeekly = lazy(() => import("./components/CalendarView/CalendarThirdParty/CalendarThirdWeekly"));
const Engage = lazy(() => import("./components/Engage/EngageSwitch"));
const AnalyticsPerPost = lazy(() => import("./components/Analytics/v2/AnalyticsSwitch").then((m) => ({ default: m.PostsSwitch })));
const AnalyticsOverview = lazy(() => import("./components/Analytics/v2/AnalyticsOverview"));
const AnalyticsPerAccount = lazy(() => import("./components/Analytics/v2/AnalyticsSwitch").then((m) => ({ default: m.AccountsSwitch })));
const SmlinkCallback = lazy(() => import("./components/smlink/SmlinkCallback"));
const LibraryMDFGrid = lazy(() => import("./components/library/v2/LibrarySwitch"));
const SMAccounts = lazy(() => import("./components/Manage/SMAccounts"));
const TeamClients = lazy(() => import("./components/Manage/TeamClients"));
const Tools = lazy(() => import("./components/Manage/Tools"));
const AffiliationIntro = lazy(() => import("./components/subscriptions/AffiliationIntro"));
const News = lazy(() => import("./components/settings/News"));
const Account = lazy(() => import("./components/settings/Account"));
const PlansMDN = lazy(() => import("./components/subscriptions/PlansMDN"));
const PlansManagement = lazy(() => import("./components/Plans/PlansManagement"));
const CancellationCustom = lazy(() => import("./components/subscriptions/CancellationCustom"));
const OrderComplete = lazy(() => import("./components/subscriptions/OrderComplete"));
const OrderCancel = lazy(() => import("./components/subscriptions/OrderCancel"));

const App = () => {
  const [authTokens, setAuthTokens] = useState(
    JSON.parse(localStorage.getItem("authTokens")) || "",
  );

  const setTokens = (data) => {
    localStorage.setItem("authTokens", JSON.stringify(data));
    setAuthTokens(data);
  };

  const headers = {
    Authorization: authTokens.token,
  };

  const { t } = useTranslation(["authorizations"]);

  const [navComponent, setNavComponent] = useState("contacts");
  const [navTitle, setNavTitle] = useState("");
  const [mediaTransfer, setMediaTransfer] = useState([]);

  const changeNav = (newTitle, navComponent) => {
    setNavTitle(newTitle);
    setNavComponent(navComponent);
  };

  const [stateModalOptions, setStateModalOptions] = useState({
    display: false,
    status: "",
    message: "",
    loader: false,
  });

  const closeStateModal = () => {
    setStateModalOptions({
      display: false,
      status: "",
      message: "",
      loader: false,
      button_text: "",
      button_link: "",
    });
  };

  const checkUnauthorizedResponse = (response) => {
    let message;
    let button_text = "";
    let button_link = "";
    let message_details = [];

    if (response.isExpired) {
      message = t("account_expired");
    } else if (response.analyticsIsExpired) {
      message = t("analytics_expired");
    } else if (response.teamIsExpired) {
      message = t("team_expired");
    } else if (response.pubMaxed) {
      message = t("pub_maxed");
    } else if (response.pubMaxedAdv) {
      message = t("pub_maxed_adv");
      button_text = t("upgrade");
      button_link = "/plans";
      message_details = response.message_details;
    } else if (response.smMaxed) {
      message = t("sm_maxed");
      button_text = t("upgrade");
      button_link = "/plans";
    } else if (response.isNotAdmin) {
      message = t("not_admin");
    } else if (response.planDoesNotallow) {
      message = t("plan_does_not_allow");
    } else if (response.teamMaxed) {
      message = t("team_maxed");
    } else {
      message = t("contact_us");
    }

    setStateModalOptions({
      ...stateModalOptions,
      display: true,
      status: "error",
      loader: false,
      message: message,
      message_details: message_details,
      button_text: button_text,
      button_link: button_link,
    });

    if (response.analyticsIsExpired) {
      setAuthTokens({
        ...authTokens,
        analytics: false,
      });
    } else if (response.teamIsExpired) {
      setAuthTokens({
        ...authTokens,
        team: false,
      });
    } else {
      setAuthTokens({
        ...authTokens,
        plan: response.plan,
        plan_expiry: response.expiry_date,
      });
    }
  };

  const [reloadHeaderData, setReloadHeaderData] = useState(false);

  const triggerHeaderReload = () => {
    setReloadHeaderData(!reloadHeaderData);
  };

  const [newMessagesNotif, setNewMessagesNotif] = useState([]);
  const [showMessageNotif, setShowMessageNotif] = useState(false);

  // Lets the Inbox keep the menu dot in line with what it shows, without re-querying every network.
  const updateAccountNotif = (accountId, hasUnread) => {
    setNewMessagesNotif((prev) => {
      const next = prev.map((n) =>
        n.account._id === accountId && n.new_message !== hasUnread ? { ...n, new_message: hasUnread } : n,
      );
      setShowMessageNotif(next.some((n) => n.new_message));
      return next;
    });
  };

  const checkMessageNotification = async () => {
    const payload = {
      company_id: authTokens.account_id,
      user_id: authTokens.user_id,
    };

    await axios
      .post(
        process.env.REACT_APP_SOCIALPIKA_API_URL +
          "/engagement/get_latest_notif/",
        payload,
        {
          headers: headers,
        },
      )
      .then((response) => {
        setNewMessagesNotif(response.data);

        let new_msg = false;
        if (response && response.data && response.data.length > 0) {
          response.data.forEach((mediaNotif) => {
            if (mediaNotif.new_message) {
              new_msg = true;
            }
          });
        }
        setShowMessageNotif(new_msg);
      })
      .catch(() => {});
  };

  return (
    <AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens }}>
      <Router>
        <Route
          render={() => (
            <Suspense fallback={<Loader />}>
            <Switch>
              {/*<Route path="/" render={(props) => <Maintenance {...props} />} />*/}
              <Route
                path="/canva_auth"
                render={(props) => <CanvaAuth {...props} />}
              />
              <Route
                path="/canva_auth_test"
                render={(props) => <CanvaAuthTest {...props} />}
              />
              <Route
                path="/signin"
                exact
                render={(props) => <SigninStripped {...props} />}
              />
              <Route
                path="/signup"
                exact
                render={(props) => <SignupStripped {...props} />}
              />
              <Route
                path="/signup_canva"
                exact
                render={(props) => <SignupCanva {...props} />}
              />
              <Route
                path="/team_signup/:id"
                exact
                render={(props) => <TeamSignupStripped {...props} />}
              />
              <Route
                path="/password_reset"
                exact
                render={(props) => <PasswordReset {...props} />}
              />
              <Route
                path="/new_password/:id"
                exact
                render={(props) => <NewPassword {...props} />}
              />
              <Route
                path="/confirm_email/:id"
                exact
                render={(props) => <EmailConf {...props} />}
              />

              <Route
                path="/onboarding"
                exact
                render={(props) => <Onboarding {...props} />}
              />
              <Route
                path="/onboarding/:id"
                exact
                render={(props) => <Onboarding {...props} />}
              />
              <Route
                path="/onboarding_confirmed/:id"
                exact
                render={(props) => <OnboardingPaymentConfirmed {...props} />}
              />

              <Route
                path="/3ps/m/:id"
                render={(props) => <CalendarThirdMonthly {...props} />}
              />
              <Route
                path="/3ps/w/:id"
                render={(props) => <CalendarThirdWeekly {...props} />}
              />

              <div className="grid-container2">
                {stateModalOptions.display ? (
                  <StateModal
                    modalOptions={stateModalOptions}
                    closeStateModal={closeStateModal}
                  />
                ) : (
                  ""
                )}
                <WhatsNew userId={authTokens.user_id} />
                <div className="grid-sidebar2">
                  <SidebarCESAM
                    changeNav={changeNav}
                    navComponent={navComponent}
                    checkMessageNotification={checkMessageNotification}
                    showMessageNotif={showMessageNotif}
                  />
                </div>
                <div className="grid-header2">
                  <Header
                    navTitle={navTitle}
                    reloadHeaderData={reloadHeaderData}
                  />
                </div>
                <div className="grid-content2">
                  <PrivateRoute
                    path="/"
                    exact
                    render={(props) => (
                      <Dashboard
                        {...props}
                        newMessagesNotif={newMessagesNotif}
                        changeNav={changeNav}
                        checkUnauthorizedResponse={checkUnauthorizedResponse}
                      />
                    )}
                  />

                  <PrivateRoute
                    path="/engage"
                    exact
                    render={(props) => (
                      <Engage
                        {...props}
                        changeNav={changeNav}
                        checkMessageNotification={checkMessageNotification}
                        updateAccountNotif={updateAccountNotif}
                        newMessagesNotif={newMessagesNotif}
                      />
                    )}
                  />

                  <PrivateRoute
                    path="/post/new_post"
                    exact
                    render={(props) => (
                      <PostEditor
                        {...props}
                        changeNav={changeNav}
                        mediaTransfer={mediaTransfer}
                        checkUnauthorizedResponse={checkUnauthorizedResponse}
                      />
                    )}
                  />
                  <PrivateRoute
                    path="/post/new_post/:id"
                    render={(props) => (
                      <PostEditor {...props} changeNav={changeNav} />
                    )}
                    checkUnauthorizedResponse={checkUnauthorizedResponse}
                  />
                  <PrivateRoute
                    path="/post/burst_post"
                    exact
                    render={(props) => (
                      <PostEditor
                        {...props}
                        changeNav={changeNav}
                        mediaTransfer={mediaTransfer}
                        checkUnauthorizedResponse={checkUnauthorizedResponse}
                      />
                    )}
                  />
                  <PrivateRoute
                    path="/post/burst_post/:id"
                    render={(props) => (
                      <PostEditor {...props} changeNav={changeNav} />
                    )}
                    checkUnauthorizedResponse={checkUnauthorizedResponse}
                  />
                  <PrivateRoute
                    path="/calendar/weekly"
                    exact
                    render={(props) => (
                      <CalendarAdvancedWeek {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path="/calendar/monthly"
                    exact
                    render={(props) => (
                      <CalendarAdvanced {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path="/grid"
                    exact
                    render={(props) => (
                      <GridViews {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path="/drafts"
                    exact
                    render={(props) => (
                      <Drafts {...props} changeNav={changeNav} />
                    )}
                  />

                  <PrivateRoute
                    path="/analytics"
                    exact
                    render={(props) => (
                      <AnalyticsOverview {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path="/analytics_per_post"
                    exact
                    render={(props) => (
                      <AnalyticsPerPost
                        {...props}
                        changeNav={changeNav}
                        checkUnauthorizedResponse={checkUnauthorizedResponse}
                      />
                    )}
                  />
                  <PrivateRoute
                    path="/analytics_per_account"
                    exact
                    render={(props) => (
                      <AnalyticsPerAccount
                        {...props}
                        changeNav={changeNav}
                        checkUnauthorizedResponse={checkUnauthorizedResponse}
                      />
                    )}
                  />

                  <PrivateRoute
                    path="/linkedinLogin"
                    exact
                    render={(props) => <LinkedInPopUp {...props} />}
                  />
                  <PrivateRoute
                    path="/linked"
                    exact
                    render={(props) => <SmlinkCallback {...props} />}
                  />
                  <PrivateRoute
                    path="/library"
                    exact
                    render={(props) => (
                      <LibraryMDFGrid
                        {...props}
                        changeNav={changeNav}
                        setMediaTransfer={setMediaTransfer}
                      />
                    )}
                  />
                  <PrivateRoute
                    path="/sm_accounts"
                    exact
                    render={(props) => (
                      <SMAccounts {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path="/sm_accounts/ig_login/"
                    render={(props) => (
                      <SMAccounts {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path="/sm_accounts/tiktok/"
                    render={(props) => (
                      <SMAccounts {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path={["/team_clients", "/team", "/third_parties"]}
                    exact
                    render={(props) => (
                      <TeamClients {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path="/lists"
                    exact
                    render={(props) => (
                      <Tools {...props} changeNav={changeNav} />
                    )}
                  />

                  <PrivateRoute
                    path="/subscription"
                    exact
                    render={(props) => (
                      <PlansMDN {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path="/plans"
                    exact
                    render={(props) => (
                      <PlansManagement
                        {...props}
                        changeNav={changeNav}
                        triggerHeaderReload={triggerHeaderReload}
                      />
                    )}
                  />
                  <PrivateRoute
                    path="/cancel_plan"
                    exact
                    render={(props) => (
                      <CancellationCustom
                        {...props}
                        changeNav={changeNav}
                        checkUnauthorizedResponse={checkUnauthorizedResponse}
                      />
                    )}
                  />
                  <PrivateRoute
                    path="/order_complete/:id"
                    exact
                    render={(props) => (
                      <OrderComplete
                        {...props}
                        changeNav={changeNav}
                        triggerHeaderReload={triggerHeaderReload}
                      />
                    )}
                  />
                  <PrivateRoute
                    path="/order_cancel"
                    exact
                    render={(props) => (
                      <OrderCancel {...props} changeNav={changeNav} />
                    )}
                  />

                  <PrivateRoute
                    path="/account"
                    exact
                    render={(props) => (
                      <Account {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path="/news"
                    exact
                    render={(props) => (
                      <News {...props} changeNav={changeNav} />
                    )}
                  />
                  <PrivateRoute
                    path="/affiliates"
                    exact
                    render={(props) => (
                      <AffiliationIntro {...props} changeNav={changeNav} />
                    )}
                  />
                </div>
                <BottomNav />
                <div className="grid-footer2">
                  <Footer navTitle={navTitle} />
                </div>
              </div>
              <Route component={NotFound} />
            </Switch>
            </Suspense>
          )}
        />
      </Router>
    </AuthContext.Provider>
  );
};

export default App;
